import './styles/index.css';

import './compat.js';

import { element, fragment } from './html.js';

// make these globally available for JSX
Object.defineProperty(window, '$element', { value: element });
Object.defineProperty(window, '$fragment', { value: fragment });

import './common.js';
import AmiContext from './ctx.js';
import Flashii from './flashii.js';
import AmiLoadingOverlay from './loadoverlay.jsx';
import './ts_chat.jsx';

const loading = new AmiLoadingOverlay(document.body, true);
const flashii = new Flashii(process.env.AMI_FII_API);

(async () => {
    window.futami = await FutamiCommon.load();

    const ami = new AmiContext(process.env.AMI_TITLE, flashii, loading);
    window.ami = ami;

    Chat.Main();
    ami.sockChat.open();
    window.addEventListener('beforeunload', () => ami.sockChat.close());
})();
